import { useEffect, useState } from "react";
import api from "../../api";
import { toast } from "../../hooks/use-toast";

export const usePromoHolidays = () => {
  const [data, setData] = useState(null);
  const reload = () => api.get("/business/promo-holidays").then(({ data }) => setData(data))
    .catch(() => setData({ holidays: [], regions: [], all_regions: {}, active_preset: null }));
  useEffect(() => { reload(); }, []);
  return [data, reload];
};

export const promoFromHoliday = (h) => ({
  preset: h.id, enabled: true, text: h.text, discount_code: h.code,
  bg_color: h.bg_color, text_color: h.text_color, ends_at: h.ends_at,
});

export const createPromoCode = async (h, suffix = "") => {
  try {
    const { data } = await api.post("/business/promo-discount", { code: h.code, value: h.pct, expires_at: h.ends_at });
    toast({ title: data.created ? `Discount code ${h.code} created` : `Discount code ${h.code} refreshed`, description: `${h.pct}% off, expires ${new Date(h.ends_at).toLocaleDateString("en-GB")}.${suffix}` });
    return true;
  } catch (err) {
    toast({ title: "Could not create discount code", description: err?.response?.data?.detail || "Try again", variant: "destructive" });
    return false;
  }
};
